import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';

/* Simple, self-contained stroke icons (no external assets) so the grid reads
   like a modern county-services portal. */
const Icon = ({ paths }) => (
  <svg
    className="quicklink__icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {paths}
  </svg>
);

const links = [
  {
    to: '/about',
    label: 'Meet Ron Johanson',
    body: 'A Big Flats family, a lifetime of work, and 107 years of local roots.',
    icon: (
      <Icon paths={<><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></>} />
    ),
  },
  {
    to: '/priorities',
    label: 'See the Priorities',
    body: 'Six clear things Ron will work on from day one for the 2nd District.',
    icon: (
      <Icon paths={<><path d="M9 11l2 2 4-4" /><rect x="3" y="4" width="18" height="16" rx="2" /></>} />
    ),
  },
  {
    to: '/values',
    label: 'Ron’s Core Values',
    body: 'Honest, transparent, efficient — the way he’s run businesses and family.',
    icon: (
      <Icon paths={<path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z" />} />
    ),
  },
  {
    to: '/family',
    label: 'Meet the Family',
    body: 'Three sons, a century of roots, and a town worth fighting for.',
    icon: (
      <Icon paths={<><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><path d="M10 20v-5h4v5" /></>} />
    ),
  },
  {
    to: '/contact',
    label: 'Volunteer or Yard Sign',
    body: 'Lend a hand, request a yard sign, or knock a few doors for Big Flats.',
    icon: (
      <Icon paths={<><path d="M12 21s-7-4.5-9-9a5 5 0 0 1 9-2 5 5 0 0 1 9 2c-2 4.5-9 9-9 9z" /></>} />
    ),
  },
  {
    to: '/contact',
    label: 'Contact the Campaign',
    body: 'Questions, ideas, or a concern about your neighborhood? Reach Ron directly.',
    icon: (
      <Icon paths={<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M4 7l8 6 8-6" /></>} />
    ),
  },
];

function QuickLinks() {
  return (
    <section className="section quicklinks-section">
      <div className="container">
        <Reveal>
          <div className="section__eyebrow">Quick Links</div>
          <h2 className="section__title">How Can We Help Big Flats?</h2>
          <p className="section__lead">
            Everything you need to get to know Ron, weigh in on the issues, and get
            involved &mdash; all in one place.
          </p>
        </Reveal>

        <div className="quicklinks">
          {links.map((l, i) => (
            <Reveal as="div" key={l.label} delay={i * 70}>
              <Link to={l.to} className="quicklink">
                <span className="quicklink__badge">{l.icon}</span>
                <span className="quicklink__text">
                  <span className="quicklink__label">{l.label}</span>
                  <span className="quicklink__body">{l.body}</span>
                </span>
                <span className="quicklink__arrow" aria-hidden="true">&rarr;</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default QuickLinks;
